module.exports = __webpack_public_path__ + "img/total-number.52901c2c.svg";